import React from "react";
import { BsArrowLeft } from "react-icons/bs";
import { BtnAlternative, BtnPrimary } from "../../../share/buttons/Btn";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";

const CreateCourseInovice = (props) => {
    return (
        <div className="overflow-hidden">
            <div className="flex justify-center items-center">
                <h4 className="text-[2rem] mt-10 text-purple-dark font-bold">
                    فاکتور هزینه‌های بوت کمپ
                </h4>
            </div>

            <div className="flex min-h-screen justify-around items-center mt-20">
                <div
                    className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                    onClick={props.prevStep}
                >
                    <BsArrowRight />
                    <span>مرحله قبل</span>
                </div>
                <div className="flex gap-5">
                    <Link to={"/"}>
                        <BtnAlternative
                            className="px-[4rem] py-9"
                            text="ذخیره پیش‌نویس بوت کمپ"
                            type="submit"
                            htmlType="submit"
                        />
                    </Link>
                    <BtnPrimary
                        className="px-[4rem] py-9"
                        text="پرداخت و انتشار بوت کمپ"
                        type="submit"
                        htmlType="submit"
                    />
                </div>
            </div>
        </div>
    );
};

export default CreateCourseInovice;
